import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import LinearProgress from '@material-ui/core/LinearProgress';

import MetricSheet from '../MetricSheet';
import { getDefaultYear } from '../../utils/impactUtils';
import ImpactAutocomplete from './ImpactAutocomplete';
import { getData } from "../../utils/apiUtils";

const useStyles = makeStyles(() => ({
  formRow: {
    display: 'flex',
    width: '100%',
    margin: '1rem, 0'
  },
  formItem: {
    width: '50%',
    margin: '1rem'
  },
  orBlock: {
    width: '5%',
    marginTop: '1.5rem'
  },
  innerFormItem: {
    width: '90%',
    margin: '1rem'
  },
  profitCenter: {
    margin: '1rem'
  }
}));

export default function CashFlowCard({ impact, updateImpact, updateMetric, createMetricYear, refreshValues: refreshValues, disabled = true }) {
  const classes = useStyles();
  const [sapProjectNumber, setSapProjectNumber] = useState(impact.sapProjectNumber);
  const [orderNumber, setOrderNumber] = useState(impact.orderNumber);
  const [fuelType, setFuelType] = useState(impact.fuelType);
  const [plantName, setPlantName] = useState(impact.plantName);
  //const [ costCentre, setCostCentre ] = useState(impact.costCentre);
  const [costElement, setCostElement] = useState(impact.costElement);
  const [profitCentre, setProfitCentre] = useState(impact.profitCentre);
  const [currentYear, setCurrentYear] = useState(getDefaultYear(impact.metricYears));
  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
  const [showProgressSnackbar, setShowProgressSnackbar] = useState(false);
  const [showSAPNumberNotFoundbar, setShowSAPNumberNotFoundbar] = useState(false);

  const [dropdowns, setDropdowns] = useState({
    project: [],
    fuelType: [],
    plantName: [],
    plantId: [],
    costElement: [],
    profitCentre: [],
    orderNumber: []
  });

  // useEffect(() => {
  //   setSapProjectNumber(impact.sapProjectNumber);
  //   setOrderNumber(impact.orderNumber);
  //   setFuelType(impact.fuelType);
  //   setPlantName(impact.plantName);
  //   //setCostCentre(impact.costCentre);
  //   setCostElement(impact.costElement);
  //   setProfitCentre(impact.profitCentre);
  // }, [ impact.sapNumberFound, impact.sapProjectNumber]);

  useEffect(() => {
    if (!impact.sapNumberFound && !impact.orderNumber && (impact.fuelType || impact.plantName
      || impact.costCentre || impact.costElement || impact.profitCentre)) {
      getData('/sap/' + impact.id + '/autocompletes', setDropdowns, () => { });
    }
  }, [impact.id]);

  useEffect(() => {
    if (impact.sapProjectNumber !== null) {
      setShowSAPNumberNotFoundbar(!impact.sapNumberFound && impact.sapProjectNumber !== '');
      impact.metricData = [];
      impact.metricYears = [];
    }
    setSapProjectNumber(impact.sapProjectNumber);
    setOrderNumber(impact.sapNumberFound ? impact.orderNumber : '');
    setFuelType(impact.sapNumberFound ? impact.fuelType : '');
    setPlantName(impact.sapNumberFound ? impact.plantName : '');
    //setCostCentre(impact.costCentre);
    setCostElement(impact.sapNumberFound ? impact.costElement : '');
    setProfitCentre(impact.sapNumberFound ? impact.profitCentre : '');
  }, [impact, impact.sapNumberFound, impact.sapProjectNumber]);

  const onYearChange = (year) => {
    refreshValues();
    setCurrentYear(year);
  };

  // const onCostCentreChange = (e) => {
  //     setCostCentre(e.target.value);
  //     updateImpact(impact.id, 'costCentre', e.target.value, () => {});
  // };

  const isDisabled = () => {
    return disabled || impact.sapNumberFound;
  };

  const onValueChange = (stateMethod) => (e) => {
    stateMethod(e.target.value);
  };

  const onImpactBlur = (element) => (e) => {
    debugger;
    if (impact[element] === e.target.value) {
      return;
    }
    // Put up the updating stuff
    setShowProgressSnackbar(true);
    updateImpact(impact.id, element, e.target.value, (data) => {
      setShowProgressSnackbar(false);
      //setShowSuccessSnackbar(true);
      setShowSAPNumberNotFoundbar(false);
      refreshValues();
    }, () => {
      setShowProgressSnackbar(false);
    });
  };
  const handleCloseSuccessSnackbar = () => {
    setShowSuccessSnackbar(false);
    setShowSAPNumberNotFoundbar(false);
  };
  const handleCloseProgressSnackbar = () => {
    setShowProgressSnackbar(false);
  };

  const updateImpactWithRefresh = (stateUpdate) => (valueId, element, value) => {
    updateImpact(valueId, element, value, (data) => {
      stateUpdate(value);
      if (data.profitCentre) {
        setDropdowns(data);
      }
      if (stateUpdate === setSapProjectNumber) {
        refreshValues();
      }
    });
  };

  const projectNumberDisabled = () => {
    return disabled || orderNumber;
  }

  const orderNumberDisabled = () => {
    return disabled || sapProjectNumber;
  }

  return (
    <div style={{ width: '100%' }}>
      <Typography variant='body1'>Add either the SAP project number or SAP Order Number and values from SAP will automatically populate (Budget, Actuals and Forecast)</Typography>
      <div className={classes.formRow}>
        <TextField
          variant='outlined'
          size='small'
          className={classes.formItem}
          onChange={onValueChange(setSapProjectNumber)}
          onBlur={onImpactBlur('sapProjectNumber')}
          value={sapProjectNumber || ''}
          label='SAP Project Number (WBS) (XXyyyy format)'
          disabled={projectNumberDisabled()}
        />
        <TextField
          variant='outlined'
          size='small'
          className={classes.formItem}
          onChange={onValueChange(setOrderNumber)}
          onBlur={onImpactBlur('orderNumber')}
          value={orderNumber || ''}
          label='Order Number'
          disabled={orderNumberDisabled()}
        />
      </div>
      <div className={classes.formRow}>
        <ImpactAutocomplete
          id={`fuel-type-auto-${impact.id}`}
          initialValue={fuelType || ''}
          type='fuelType'
          valueId={impact.id}
          autocompleteURL={`/sap/${impact.id}/fuelType/`}
          updateImpact={updateImpactWithRefresh(setFuelType)}
          label='Fuel Type'
          disabled={isDisabled()}
          className={classes.formItem}
          autoCompleteValues={dropdowns.fuelType}
        />
        <ImpactAutocomplete
          id={`plant-name-${impact.id}`}
          initialValue={plantName || ''}
          type='plantName'
          valueId={impact.id}
          autocompleteURL={`/sap/${impact.id}/plantName/`}
          updateImpact={updateImpactWithRefresh(setPlantName)}
          label='Plant/Location'
          disabled={isDisabled()}
          className={classes.formItem}
          autoCompleteValues={dropdowns.plantName}
        />

      </div>
      <div className={classes.formRow}>
        <div style={{ width: '45%' }}>
          <ImpactAutocomplete
            id={`cost-element-${impact.id}`}
            initialValue={costElement || ''}
            type='costElement'
            valueId={impact.id}
            autocompleteURL={`/sap/${impact.id}/costElement/`}
            updateImpact={updateImpactWithRefresh(setCostElement)}
            label='Cost Element'
            disabled={isDisabled()}
            className={classes.innerFormItem}
            autoCompleteValues={dropdowns.costElement}
          />

        </div>
        <Typography className={classes.orBlock}>
          OR
        </Typography>
        <div style={{ width: '50%' }}>
          <ImpactAutocomplete
            id={`profit-center-${impact.id}`}
            initialValue={profitCentre || ''}
            type='profitCentre'
            valueId={impact.id}
            autocompleteURL={`/sap/${impact.id}/profitCentre/`}
            updateImpact={updateImpactWithRefresh(setProfitCentre)}
            label='Profit Centre'
            disabled={isDisabled()}
            className={classes.profitCenter}
            autoCompleteValues={dropdowns.profitCentre}
          />
        </div></div>
      <MetricSheet
        impact={impact}
        currentYear={currentYear}
        onYearChange={onYearChange}
        updateMetric={updateMetric}
        createMetricYear={createMetricYear}
        disabled={disabled}
        isCashFlow={true}
        formatNumbersAsCurrency={true}
      />
      <Snackbar open={showSuccessSnackbar} autoHideDuration={10000} onClose={handleCloseSuccessSnackbar}>
        <Alert onClose={handleCloseSuccessSnackbar} severity="success">
          Successfully saved the change!
        </Alert>
      </Snackbar>
      <Snackbar open={showProgressSnackbar} >
        <Alert onClose={handleCloseProgressSnackbar} severity="info">
          Saving the changes!<LinearProgress />
        </Alert>
      </Snackbar>
      <Snackbar open={showSAPNumberNotFoundbar} autoHideDuration={10000} onClose={handleCloseSuccessSnackbar}>
        <Alert onClose={handleCloseSuccessSnackbar} severity="warning">
          SAP Project Number not found!
        </Alert>
      </Snackbar>
    </div>
  )
}
